import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import BookMockup from './BookMockup';

const Hero=()=> {
  const scrollToForm = () => document.getElementById('cadastro')?.scrollIntoView({behavior: 'smooth'});

  return (
    <section className="relative pt-12 pb-24 overflow-hidden min-h-[90vh] flex items-center bg-[#FAF8F5]">
      <div className="absolute top-0 right-0 w-[50%] h-[60%] bg-amber-100/20 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[40%] h-[50%] bg-stone-200/40 blur-[100px] rounded-full translate-y-1/4 -translate-x-1/4" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 1,ease: [0.16,1,0.3,1]}} 
            className="flex-1 text-center lg:text-left"
          >
            <motion.img 
              src="https://i.imgur.com/LJ9Fcbk.png" 
              alt="UniPET Logo" 
              className="h-16 sm:h-20 w-auto mb-8 mx-auto lg:mx-0 object-contain drop-shadow-sm" 
              initial={{opacity: 0,scale: 0.9}} 
              animate={{opacity: 1,scale: 1}} 
              transition={{duration: 0.8}} 
            />
            
            <div className="inline-flex items-center gap-3 mb-8 px-5 py-2 rounded-full bg-white border border-stone-200 shadow-sm">
              <SafeIcon name="MapPin" className="w-4 h-4 text-amber-800" />
              <span className="text-[10px] font-bold tracking-[0.3em] text-stone-500 uppercase">Juiz de Fora • Centro</span>
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-stone-900 leading-[1.15] mb-8 max-w-2xl mx-auto lg:mx-0">
              O bem-estar do seu Pet elevado ao <span className="italic text-amber-800 font-normal">Nível Premium.</span>
            </h1>

            <p className="text-lg sm:text-xl text-stone-600 mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed font-medium">
              A <strong>UniPET</strong> é o centro de estética animal em Juiz de Fora especializado em cuidados de alto padrão. Unimos materiais de excelência a um atendimento individualizado.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-8 mb-12">
              <div className="bg-amber-50 border border-amber-200/50 px-8 py-5 rounded-2xl text-center lg:text-left shadow-sm">
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-800 block mb-1">Oferta de Boas-vindas</span>
                <p className="text-3xl font-black text-stone-900 tracking-tighter">15% OFF</p>
                <p className="text-stone-500 text-xs font-serif italic">No primeiro agendamento</p>
              </div>
            </div>

            <button 
              onClick={scrollToForm}
              className="group flex items-center gap-4 bg-stone-900 text-white px-10 py-5 rounded-xl font-bold uppercase tracking-[0.2em] text-xs hover:bg-stone-800 transition-all shadow-xl hover:shadow-stone-300 w-full sm:w-auto justify-center"
            >
              Garantir Cupom e Acesso VIP <SafeIcon name="ArrowRight" className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </motion.div>

          <motion.div initial={{opacity: 0,scale: 0.95}} animate={{opacity: 1,scale: 1}} transition={{duration: 1.5,delay: 0.2}} className="flex-1 w-full lg:auto">
            <BookMockup />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;